// Desktop installers, platform detection and download-click handling, shared by the
// download page(s) and the guide-page download buttons.
//
// A download click is tracked as the existing GA4 key event `download_<platform>_clicked`
// and announced with a window event that opens the "Your download is starting" panel
// (DownloadStartedPanel, mounted once in App.vue).

export const INSTALLERS = {
  windows: {
    label: 'Windows',
    url: 'https://downloads.rallynavigator.com/Rally%20Navigator%20Installer.exe',
    file: 'Rally Navigator Installer.exe',
  },
  mac: {
    label: 'Mac',
    url: 'https://downloads.rallynavigator.com/Rally%20Navigator%20Installer.dmg',
    file: 'Rally Navigator Installer.dmg',
  },
  linux: {
    label: 'Linux',
    url: 'https://downloads.rallynavigator.com/Rally%20Navigator%20Installer.AppImage',
    file: 'Rally Navigator Installer.AppImage',
  },
};

export const DOWNLOAD_STARTED_EVENT = 'rn-download-started';

/**
 * 'windows' | 'mac' | 'linux' for a desktop, 'phone' for phones/tablets, or null when
 * unknown. Returns null for automated browsers (the prerenderer is headless Chrome on a
 * Mac), so prerendered HTML never bakes in one visitor's platform.
 */
export function detectPlatform() {
  if (typeof navigator === 'undefined' || navigator.webdriver) return null;
  const ua = navigator.userAgent || '';
  const platform = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';
  // iPadOS reports itself as a Mac; a touch-capable "Mac" is an iPad.
  if (/iPhone|iPad|iPod|Android|Mobile/i.test(ua)) return 'phone';
  if (/Mac/i.test(platform) && navigator.maxTouchPoints > 1) return 'phone';
  if (/Win/i.test(platform) || /Windows/i.test(ua)) return 'windows';
  if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) return 'mac';
  if (/Linux|X11|CrOS/i.test(platform) || /Linux/i.test(ua)) return 'linux';
  return null;
}

/**
 * Handle a click on an installer link: GA4 key event + open the next-steps panel.
 * `variant` is '' for the current release or '_previous' for the previous-version row.
 */
export function downloadClicked(platform, { variant = '', location = 'download_page', url = null } = {}) {
  if (typeof window === 'undefined') return;
  if (window.gtag) {
    window.gtag('event', `download_${platform}${variant}_clicked`, {
      event_category: 'downloads',
      event_label: platform,
      app_platform: 'website',
      link_location: location,
      page_path: window.location.pathname,
      value: 1,
    });
  }
  // `url` is passed for a specific file (e.g. the previous release) so the panel names it
  // and its fallback link re-downloads that file, not the current one.
  window.dispatchEvent(new CustomEvent(DOWNLOAD_STARTED_EVENT, { detail: { platform, url } }));
}
